class FeaturedProductForm extends HTMLElement {
  connectedCallback() {
    let variantData = JSON.parse(this.getAttribute("data-variants"));
    let variantSelect = this.querySelector(".pr_variants");
    let hasOpt2 = this.querySelector(".option2") != null;
    let variantSelectorButtons = hasOpt2 ? this.querySelectorAll(".option2 .swatch-element") : this.querySelectorAll(".swatch-element");

    variantSelectorButtons.forEach((ele) => {
      ele.addEventListener("click", (e) => {
        let variant = variantData.find(
          (variant) =>
            variant.id === parseInt(ele.querySelector('.swatchLbl').getAttribute('varid')),
        );

        if (!variant) return;

        this.updateOptionPrices(variant)
        this.querySelector('selling-plan-widget').setAttribute("data-variantselected", variant.id)
        if(this.querySelector('[name="selling_plan"]').value != ''){
          this.querySelector('[name="selling_plan"]').value = this.querySelector(`[data-sellingplansfor="${variant.id}"]`).value
        }
      });
    });
  }

  updateOptionPrices(variant) {
    const comparePrice = variant.compare_price;
    const salePrice = variant.subscription_price ?? variant.price;

    this.querySelector(".purchase-option--compare-price").textContent =
      comparePrice && stringToNumber(comparePrice) > stringToNumber(salePrice)
        ? comparePrice.replace("AUD", "")
        : "";

    this.querySelector(".purchase-option--price").textContent = salePrice
      ? salePrice.replace("AUD", "")
      : "";
  }
}

customElements.define("featured-product-form", FeaturedProductForm);
